import { ReportColumnConfig } from "components/ReportGrid_New/types";

export const EMAIL_REPORT ="Email Report"
export const EMAIL_REPORT_TITLE ="emailReport"
export const EMAIL_INFO_MESSAGE ="Displays the Email report for the date range provided"

export const columns: ReportColumnConfig[] = [
  { name: 'repairerName', title: 'Repairer Name' },
  { name: 'repairerGroup', title: 'Repairer Group' },
  { name: 'schemeCode', title: 'Scheme Code' },
  { name: 'workProvider', title: 'Work Provider' },
  { name: 'regmark', title: 'Vehicle Reg.' },
  { name: 'emailSentDate', title: 'Email Date and Time', type: 'date' },
  { name: 'subject', title: 'Email Subject', width: '200' },
];

export const summaryItems = [{ columnName: 'repairerName', type: 'count', customizeText: ({value}: {value: string | number | Date})  => `Total Messages: ${value}`}];

